const initialState = {
  mapbox_api_key: process.env.REACT_APP_MAPBOX_API_KEY,
  map: null,
  map_ready: false,
  geojson_pda: {},
  geojson_pch: {},
  mode_chart: "7",
  status_action: 0,
  fly_action: 0,
  mode_fitur: "",
  mode_draw: "simple_select",
  sini_action: 0,
  simple_map_action: 0,
  feature_key_survey: "",
  feature_key_pembanding_list: [],
  provinsi: "",
  kota: "",
  kecamatan: "",
  kelurahan: "",
  poi_input_list: [
    "ATM DAN BANK",
    "FASILITAS UMUM",
    "RETAIL",
    "TEMPAT MAKAN/MINUM",
  ],
  grid: {
    type: "FeatureCollection",
    features: [],
  },
  grid_status: false,
  sidebar: "get_data",
  count_poi: 1,
  current_progress_create_layer: 0,
  basemap_mode: "street-2d-building",
  basemap_api:
    "https://basemap.mapid.io/styles/street-2d-building/style.json?key=rahasia123",
  //"https://basemap.mapid.io/styles/basic/style.json?key=rahasia123",
  //https://api.maptiler.com/maps/streets/style.json?key=CVYOeJckfxqURN5wjKEB
  //mapbox://styles/mapbox/streets-v12
  genangan_view_status: true,
  refresh_nested_table: false,
};

export default function dataReducer(state = initialState, action) {
  switch (action.type) {
    case "set_value_map":
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    case "set_mode_fitur":
      return {
        ...state,
        mode_fitur: action.payload,
      };
    case "set_mode_draw":
      return {
        ...state,
        mode_draw: action.payload,
      };
    case "simple_map_action":
      return {
        ...state,
        simple_map_action: state.simple_map_action + 1,
      };
    case "sini_action":
      return {
        ...state,
        sini_action: state.sini_action + 1,
      };
    case "fly_action":
      return {
        ...state,
        fly_action: state.fly_action + 1,
      };
    case "status_action":
      return {
        ...state,
        status_action: state.status_action + 1,
      };
    case "set_value_layer":
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      };
    case "get_pch":
      return {
        ...state,
        geojson_pch: action.payload,
      };
    case "get_pda":
      return {
        ...state,
        geojson_pda: action.payload,
      };
    case "set_map":
      return {
        ...state,
        map: action.payload,
      };

    default:
      return state;
  }
}
